import PropTypes from 'prop-types';
import React from 'react';

var SubNavigationItem = function SubNavigationItem(_ref) {
  var eventKey = _ref.eventKey,
      href = _ref.href,
      children = _ref.children,
      onClick = _ref.onClick,
      className = _ref.className;

  var handleClick = function handleClick(e) {
    if (onClick) {
      e.preventDefault();
      onClick(eventKey, e);
    }
  };

  return React.createElement("a", {
    href: href,
    className: className,
    onClick: handleClick
  }, children);
};

SubNavigationItem.displayName = 'SubNavigationItem';
SubNavigationItem.propTypes = {
  eventKey: PropTypes.any,
  href: PropTypes.string.isRequired,
  children: PropTypes.any,
  onClick: PropTypes.func,
  className: PropTypes.string
};
export default SubNavigationItem;